import type { Content } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { cm, pdfColors } from '../../theme.pdf';
import { BLOCK_SPACING } from '../layout';
import { buildScorecardChartSvg } from '@/features/reports/utils/scorecardChartSvg';

const CHART_WIDTH_CM = 17;

type ScorecardChartBlock = Extract<ViewBlock, { type: 'scorecard-chart' }>;

export function renderScorecardChartBlock(block: ScorecardChartBlock): Content {
  const { svg } = buildScorecardChartSvg({
    entries: block.entries,
    series: block.series,
  });

  const noteText = block.noteValue?.trim() ?? '';

  const noteStack: Content = {
    stack: [
      {
        text: 'Note:',
        style: 'tableCellLabel',
        margin: [0, cm(0.1), 0, cm(0.05)],
      },
      noteText
        ? {
            text: noteText,
            style: 'tableCell',
            margin: [0, 0, 0, cm(0.1)],
          }
        : {
            text: ' ',
            margin: [0, 0, 0, cm(0.2)],
          },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: cm(CHART_WIDTH_CM),
            y2: 0,
            lineWidth: 0.5,
            lineColor: pdfColors.borderGray,
          },
        ],
        margin: [0, 0, 0, 0],
      },
    ],
  };

  return {
    unbreakable: true,
    stack: [
      {
        text: block.title,
        style: 'tableCellLabel',
        margin: [0, 0, 0, cm(0.15)],
      },
      {
        table: {
          widths: [cm(CHART_WIDTH_CM)],
          body: [
            [
              {
                svg,
                width: cm(CHART_WIDTH_CM),
                margin: [cm(0.2), cm(0.2), cm(0.2), cm(0.2)],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => pdfColors.borderGray,
          vLineColor: () => pdfColors.borderGray,
          fillColor: () => '#FAFAFA',
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
        margin: [0, 0, 0, cm(0.2)],
      },
      noteStack,
    ],
    margin: [0, 0, 0, BLOCK_SPACING],
  };
}
